<template>
  <div class="proposal-evaluation-header">
    <div class="row">
      <div class="col-12 col-md-9 proposal-evaluation-header__expectation">
        Expectativa
      </div>

      <div
        v-for="(value, index) of values"
        :key="index"
        class="col-4 col-md-1 proposal-evaluation-header__qualification"
        :style="{ '--bg-color': value.bgColor }"
      >
        {{ value.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProposalEvaluationHeader',
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.proposal-evaluation-header {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;

  &__expectation,
  &__qualification {
    height: 59px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-left: 1px solid white;
  }

  &__expectation {
    background-color: map-get($colors, 'gray-5');
    color: map-get($colors, 'black');
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &__qualification {
    --bg-color: map-get($colors, 'gray-5');
    color: #393737;
    background-color: var(--bg-color);

    &:last-child {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
  }
}
</style>
